var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modal" } }, [
    _vm.item.name
      ? _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            {
              staticClass: "modal-wrapper",
              on: {
                click: function ($event) {
                  return _vm.close($event)
                },
              },
            },
            [
              _c("div", { staticClass: "modal-container" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h3", [_vm._v("Сертификаты")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-close-modal",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.certificates
                    ? _c(
                        "div",
                        { staticClass: "sertificates" },
                        [
                          _c("vue-swiper", {
                            key: _vm.item.id,
                            attrs: {
                              images: _vm.certificates,
                              "item-id": _vm.item.id,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "a",
                    {
                      staticClass: "modal-default-button",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v("\n            Закрыть\n          ")]
                  ),
                ]),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }